/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import * as EventHandler from '../../../services/EventHandler';

import * as Actions from '../../../actions/actions';

export class GetQuotesButton extends Component {
    onClick() {
        if (this.props.handler) {
            this.props.handler();
        }

        if (!this.props.canSubmit) {
            return;
        }

        EventHandler.track('Clicked Get Your Quotes', {
            category: 'Landing Page',
            label: this.props.section,
        });
    }

    render() {
        let className = 'button';
        if (this.props.size === 'big') {
            className = 'big-button';
        }

        return (
            <button className={ `${className} vouchedfor-brand landing-page` }
                    onClick={ this.onClick.bind(this) } >
                { this.props.wording || 'Find the best adviser for me' }
            </button>
        );
    }
}

GetQuotesButton.propTypes = {
    canSubmit: React.PropTypes.bool,
    handler: React.PropTypes.func,

    section: React.PropTypes.string,
    wording: React.PropTypes.string,

    actions: React.PropTypes.object,

    size: React.PropTypes.string,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        canSubmit: state.navigation.get('canSubmit'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GetQuotesButton);



// WEBPACK FOOTER //
// ./src/components/steps/landing/GetQuotesButton.jsx